import { Component } from 'react'
import PropTypes from 'prop-types'
import { findDOMNode } from 'react-dom'
import { DragSource, DropTarget } from 'react-dnd'
import { ItemTypes } from './ItemTypes'
import {
  Switch,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core'
import { Sms, Email, Phone, VerifiedUser } from '@material-ui/icons'

function Listing(props) {
  const text = props.text
  if (text === 'SMS') {
    return (
      <ListItemIcon>
        <Sms />
      </ListItemIcon>
    )
  } else if (text === 'Phone') {
    return (
      <ListItemIcon>
        <Phone />
      </ListItemIcon>
    )
  } else if (text === 'Email') {
    return (
      <ListItemIcon>
        <Email />
      </ListItemIcon>
    )
  } else {
    return (
      <ListItemIcon>
        <VerifiedUser />
      </ListItemIcon>
    )
  }
}

const style = {
  cursor: 'move',
}

const cardSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index,
    }
  },
}

const cardTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index
    const hoverIndex = props.index

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

    // Determine mouse position
    const clientOffset = monitor.getClientOffset()

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return
    }

    // Time to actually perform the action
    props.moveListItem(dragIndex, hoverIndex)

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex
  },
}

const withDropTarget = DropTarget(
  ItemTypes.LIST_ITEM,
  cardTarget,
  (connect) => ({
    connectDropTarget: connect.dropTarget(),
  }),
)

const withDropSource = DragSource(
  ItemTypes.LIST_ITEM,
  cardSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  }),
)

class ReorderListItem extends Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    handleOnClick: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    isDragging: PropTypes.bool.isRequired,
    id: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.number.isRequired,
    ]),
    text: PropTypes.string.isRequired,
    moveListItem: PropTypes.func.isRequired,
  }

  render() {
    const {
      text,
      isDragging,
      connectDragSource,
      connectDropTarget,
      // props for onClick selection
      handleOnClick,
      // For tracking if last item
      index,
      checked,
    } = this.props

    const opacity = isDragging ? 0 : 1
    // console.log(index)
    if (index === 2) {
      return connectDragSource(
        connectDropTarget(
          <div style={{ ...style, opacity }}>
            <ListItem>
              <Listing text={text} />
              <ListItemText primary={text} />
              <ListItemSecondaryAction>
                <Switch onChange={handleOnClick} checked={checked} />
              </ListItemSecondaryAction>
            </ListItem>
          </div>,
        ),
      )
    } else {
      return connectDragSource(
        connectDropTarget(
          <div style={{ ...style, opacity }}>
            <ListItem divider>
              <Listing text={text} />
              <ListItemText primary={text} />
              <ListItemSecondaryAction>
                <Switch onChange={handleOnClick} checked={checked} />
              </ListItemSecondaryAction>
            </ListItem>
          </div>,
        ),
      )
    }
  }
}

export default withDropTarget(withDropSource(ReorderListItem))
